export default __webpack_public_path__ + "static/media/light-blue-info.72b4477b.svg";